import { Entity, IEntity } from "./Entity";
import { IUser } from "./User";
import { IApp04Topic } from "./App04Topic";

export interface IApp04TopicUser extends IEntity {
    TopicID?: number;
    UserID?: number;
    Topic?: IApp04Topic;
    User?: IUser;
}

export class App04TopicUser extends Entity implements IApp04TopicUser {
    public TopicID = null;
    public UserID = null;
    public Topic = null;

    constructor() {
        super();
    }
}